/**
 * Scot.js
 * Created by zl952fc on 02/24/2020.
 */

import React from 'react';
import {SVGICONS} from '@ey/icons';
import styled from 'styled-components';
import {labels} from '../../../util/uiconstants';
import NotificationList from './NotificationList';

export default function NotificationGroups(props) {
	const {
		notifications,
		onFirstButtonClick,
		onSecondButtonClick,
		setCloseNotification
	} = props;

	const closeNotification = () => {
		props.closeNotification();
	};

	return (
		<NotificationsGroup className="NotificationsGroupContainer">
			<section className="NotificationGroupHeader">
				<span className="NotificationGroupTitle">{labels.notifcenter}</span>
				<button
					title={labels.closeNotificationCenter}
					className="NotificationCloseBtn"
					onClick={closeNotification}
				>
					<SVGICONS
						hoverText="Close notification center"
						styleName="medium"
						name="close-outline"
						alt="Close notification center"
					/>
				</button>
			</section>
			{notifications && notifications.length > 0 ? (
				notifications.map((notification) => {
					return (
						<NotificationList
							key={notification.actionType}
							close={notifications.close}
							notification={notification}
							setCloseNotification={setCloseNotification}
							onFirstButtonClick={onFirstButtonClick}
							onSecondButtonClick={onSecondButtonClick}
							acceptedEngagementList={props.acceptedEngagementList}
							acceptedArchiveEngagementList={
								props.acceptedArchiveEngagementList
							}
							isInviteAcceptedOrRejected={props.isInviteAcceptedOrRejected}
							isArchiveInviteAcceptedOrRejected={
								props.isArchiveInviteAcceptedOrRejected
							}
							setisInviteAcceptedOrRejectedToDone={
								props.setisInviteAcceptedOrRejectedToDone
							}
							setisArchiveInviteAcceptedOrRejectedToDone={
								props.setisArchiveInviteAcceptedOrRejectedToDone
							}
						/>
					);
				})
			) : (
				<>
					{(!notifications ||
						(notifications && notifications.length === 0)) && (
						<section className="emptyContainer">
							{labels.noNotifications}
						</section>
					)}
				</>
			)}
		</NotificationsGroup>
	);
}

const NotificationsGroup = styled.section`
	line-height: var(--px-33);

	.NotificationGroupHeader {
		display: flex;
		padding: var(--px-10) var(--px-15);
		.NotificationGroupTitle {
			font-size: var(--px-16);
			font-weight: bold;
			flex-grow: 1;
			color: var(--neutrals-900);
		}
		.NotificationCloseBtn {
			background: transparent;
			border: none;
			svg {
				fill: var(--neutrals-900) !important;
				margin-top: var(--px-5);
			}
		}
	}
	.emptyContainer {
		border-top: var(--px-1) solid var(--neutrals-200);
		padding: var(--px-10) var(--px-15);
		text-align: center;
		color: var(--neutrals-700);
		font-size: var(--px-14);
	}
`;
